/* eslint-disable ember/classic-decorator-hooks, ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import { tracked } from '@glimmer/tracking';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import PageType from 'linced-app/enums/page-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  queryParams = {
    pageId: {
      refreshModel: false,
    },
    proofreadPosts: {
      refreshModel: false,
    },
    notProofread: {
      refreshModel: false,
    },
    draftPosts: {
      refreshModel: false,
    },
    publishedPosts: {
      refreshModel: false,
    },
    staffOnly: {
      refreshModel: false,
    },
    selectedPageIds: {
      refreshModel: false,
    },
    selectedAuthorIds: {
      refreshModel: false,
    },
    startDate: {
      refreshModel: false,
    },
    endDate: {
      refreshModel: false,
    },
  };

  // Services
  @service
  router;

  @service
  store;

  @tracked
  clearFilters;

  model() {
    let group = this.modelFor('group');
    return hash({
      group,
      pages: this.store
        .query('posts/page', {
          type: PageType.STUDENT,
          visibleInMenu: true,
        })
        .then((pages) => {
          return pages.filter((page) => page.hasPosts);
        }),
      authors: this.store.query('person', {
        type: PersonType.STAFF,
      }),
    });
  }

  @action
  queryParamsDidChange() {
    // TODO: This call to super is within an action, and has to refer to the parent
    // class's actions to be safe. This should be refactored to call a normal method
    // on the parent class. If the parent class has not been converted to native
    // classes, it may need to be refactored as well. See
    // https://github.com/scalvert/ember-native-class-codemod/blob/master/README.md
    // for more details.
    super.actions.queryParamsDidChange.call(this, ...arguments);
    if (!isEmpty(this.controller)) {
      this.controller.loadPosts();
    }
  }

  init() {
    super.init(...arguments);

    this.router.on('routeWillChange', (transition) => {
      let from = transition.from;
      if (
        isEmpty(from) ||
        !transition.to.find((route) => route.name === this.routeName)
      ) {
        return;
      }
      if (
        !from.find(
          (route) =>
            route.name === this.routeName ||
            route.name === 'group.bulk-publish',
        )
      ) {
        if (!isEmpty(this.controller)) {
          this.clearFilters = true;
        }
      }
    });
  }

  setupController() {
    super.setupController(...arguments);
    if (this.clearFilters) {
      this.controller.clearFilters();
    }
    this.controller.loadPosts();
  }
}
